import React from "react";
import ProgressBar from "react-customizable-progressbar";

const NestedCircularProgress = ({
  labeledRecords,
  irrelevantRecords,
  relevantRecords,
  totalRecords,
}) => {
  return (
    <div className="nested-circular-progress">
      <div style={{display:'flex',justifyContent:'center'}}>
      <ProgressBar
        className="first-circle"
        radius={80}
        progress={(relevantRecords / totalRecords) * 100}
        strokeColor="#ffc107"
        pointerStrokeWidth={0}
        strokeWidth={10}
        trackStrokeWidth={10}
        pointerStrokeColor="#7bcd5c"
        initialAnimationDelay={1000}
        initialAnimation={true}
        trackTransition=".1s ease"
        transition="1s ease"
      >
        <div className="indicator">
          <ProgressBar
            radius={65}
            className="second-circle"
            progress={(irrelevantRecords / totalRecords) * 100}
            strokeWidth={10}
            trackStrokeWidth={10}
            strokeColor="#f35e1d"
            pointerStrokeWidth={0}
            pointerStrokeColor="#7bcd5c"
            initialAnimationDelay={1000}
            initialAnimation={true}
            trackTransition=".1s ease"
            transition="1s ease"
          >
            <div className="indicator-2">
              <ProgressBar
                radius={50}
                className="third-circle"
                progress={(labeledRecords / totalRecords) * 100}
                strokeColor="#17a2b8"
                strokeWidth={10}
                trackStrokeWidth={10}
                pointerStrokeWidth={0}
                pointerStrokeColor="#7bcd5c"
                initialAnimationDelay={1000}
                initialAnimation={true}
                trackTransition=".1s ease"
                transition="1s ease"
              >
                {/* Total Article Text in the Center */}
                <div className="center-text">
                  Total Articles
                  <br />
                  {totalRecords}
                </div>
              </ProgressBar>
            </div>
          </ProgressBar>
        </div>
      </ProgressBar>
      </div>
      <div className="legend">
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: "#17a2b8" }}></span>
          Labeled Records
        </div>
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: "#f35e1d" }}></span>
          Irrelevant Records
        </div>
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: "#ffc107" }}></span>
          Relevant Records
        </div>
      </div>
    </div>
  );
};

export default NestedCircularProgress;
